import { createContext } from 'react';

export type FundAccountCtx = {
  showFundAccountErrorAlert: boolean;
  fundAccountError: string;
};

const FundAccountDialogueContext = createContext<FundAccountCtx>({
  showFundAccountErrorAlert: false,
  fundAccountError: '',
});

export default FundAccountDialogueContext;